import React,{Fragment} from 'react';
import { FaTrash,FaSave } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import {Radio,RadioGroup,FormControlLabel,FormControl,FormLabel,Typography,TextField,Grid} from '@mui/material';
import { MdOutlineReportProblem } from "react-icons/md";
import CustomDialog from "../../../components/CustomDialog";
import SaveLoading from '../../../components/SaveLoading';

const PurchasedReportModal = (props) => {
    const { open, setOpen, type, editedData, setEditedData, handleSave, saveLoading, isMobile } = props;

    const handleOnTextChange = (value, name) => {
        setEditedData((prevData) => ({
            ...prevData,
            [name]: value,
            ...(name === "isHome" && {
                isHome: true,
                isAway: false,
                isOver: false,
                isUnder: false
            }),
            ...(name === "isAway" && {
                isHome: false,
                isAway: true,
                isOver: false,
                isUnder: false
            }),
            ...(name === "isOver" && {
                isHome: false,
                isAway: false,
                isOver: true,
                isUnder: false
            }),
            ...(name === "isUnder" && {
                isHome: false,
                isAway: false,
                isOver: false,
                isUnder: true
            })
        }));
    };

    const handleClose = () => setOpen(false);

    return (
        <CustomDialog open={open} isMobile={isMobile}>
            {saveLoading &&
                <SaveLoading loading={saveLoading} />
            }
            {
                type === "edit" ?
                    <Fragment>
                        <Grid container spacing={2} className='flex items-center'>
                            <FormControl>
                                <FormLabel id="demo-row-radio-buttons-group-label" style={{ fontSize: '0.875rem' }}>Type</FormLabel>
                                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
                                    <FormControlLabel
                                        value="isHome"
                                        control={<Radio size="small" checked={editedData?.isHome} onChange={() => handleOnTextChange(true, 'isHome')} />}
                                        label="Home"
                                        size="small"
                                    />
                                    <FormControlLabel
                                        value="isAway"
                                        control={<Radio size="small" checked={editedData?.isAway} onChange={() => handleOnTextChange(true, 'isAway')} />}
                                        label="Away"
                                        size="small"
                                    />
                                    <FormControlLabel
                                        value="isOver"
                                        control={<Radio size="small" checked={editedData?.isOver} onChange={() => handleOnTextChange(true, 'isOver')} />}
                                        label="Over"
                                        size="small"
                                    />
                                    <FormControlLabel
                                        value="isUnder"
                                        control={<Radio size="small" checked={editedData?.isUnder} onChange={() => handleOnTextChange(true, 'isUnder')} />}
                                        label="Under"
                                        size="small"
                                    />
                                </RadioGroup>
                            </FormControl>
                            <Grid item xs={4}>
                                <Typography>Amount</Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    id="outlined-basic"
                                    label="Amount"
                                    variant="outlined"
                                    size="small"
                                    value={editedData?.betAmount || ''}
                                    onChange={(e) => handleOnTextChange(e.target.value, 'betAmount')}
                                    style={{ fontSize: '0.8rem' }}
                                    InputLabelProps={{
                                        style: { fontSize: '0.8rem' }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Typography>Remark</Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    id="outlined-basic"
                                    label="Remark"
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => handleOnTextChange(e.target.value, 'remark')}
                                    value={editedData?.remark || ''}
                                    style={{ fontSize: '0.8rem' }}
                                    InputLabelProps={{
                                        style: { fontSize: '0.8rem' }, // Adjust label size here
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <div className='flex justify-center items-center gap-4 mt-3'>
                            <div className='flex items-center gap-2'>
                                <button
                                    className='flex items-center px-3 py-1 border rounded bg-customTitleColor'
                                    onClick={() => handleClose()}
                                ><ImCross className='mr-1' />Close
                                </button>
                            </div>
                            <div className='flex items-center gap-2'>
                                <button
                                    onClick={() => handleSave("edit", editedData)}
                                    className='flex items-center px-3 py-1 border rounded bg-background text-customBackColor'
                                >
                                    <FaSave className='mr-1' />Save
                                </button>
                            </div>
                        </div>
                    </Fragment>
                    :
                    <Fragment>
                        <div className='flex justify-center'>
                            <MdOutlineReportProblem className='text-2xl text-red-600' />
                        </div>
                        <Typography className='dark:text-customWhite'>
                            Are you sure you want to delete this data ?
                        </Typography>
                        <div className='flex justify-center items-center gap-4 mt-2'>
                            <div className='flex items-center gap-2'>
                                <button
                                    className='flex items-center px-3 py-1 border rounded bg-customTitleColor'
                                    onClick={() => handleClose()}
                                ><ImCross className='mr-1' />Close
                                </button>
                            </div>
                            <div className='flex items-center gap-2'>

                                <button
                                    onClick={() => handleSave("delete", editedData)}
                                    className='flex items-center px-3 py-1 border rounded bg-customFontRed text-customBackColor'
                                >
                                    <FaTrash className='mr-1' />Delete
                                </button>
                            </div>
                        </div>
                    </Fragment>
            }
        </CustomDialog>
    )
}

export default PurchasedReportModal;